/* eslint-disable global-require */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import * as Sentry from '@sentry/react';

import App from './App';
import { store, history } from './Redux/store';
import * as serviceWorker from './serviceWorker';
import PackageJson from '../package.json';

if (process.env.REACT_APP_ENV !== 'dev') {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_URL,
        // integrations: [new Integrations.BrowserTracing()],
        environment: process.env.REACT_APP_ENV,
        tracesSampleRate: 0.2,
        autoSessionTracking: false,
        release: PackageJson.version,
        tunnel: process.env.REACT_APP_SENTRY_TUNNEL_URL,
    });
}

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
